module.exports = __webpack_public_path__ + "static/media/Depti.48742a27.png";